import { lazy, Suspense } from 'react'
import Loading from '../Loading'
import SoldsDataTable from './ADMIN/components/SoldsDataTable'

const SendRequestCheckout = lazy(() => import('./SendRequestCheckout'))
const LastsSubject = lazy(() => import('../loops/LastsSubject'))
const TraficTableProducer = lazy(() => import('./ADMIN/components/TraficTableProducer'))
const ChartData = lazy(() => import('./ChartData'))


export default function ProducerDashboard() {

  return (
    <>
      <div className='is_content'>
        <div className='contentHolder'>
          <div className='row'>
            <div className='col-md-4'>
              <Suspense fallback={<Loading styles='mini' />}>
                <SendRequestCheckout />
              </Suspense>
            </div>

            <div className='col-md-8'>
              <Suspense fallback={<Loading styles='mini' />}>
                <LastsSubject producer={true} page={1} pageSize={8} />
              </Suspense>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='box_radios'>
                <Suspense fallback={<Loading styles='mini' />}>
                  <ChartData />
                </Suspense>
              </div>
            </div>
          </div>

          <Suspense fallback={<Loading styles='mini' />}>
            <SoldsDataTable />
          </Suspense>

          <div className='row'>
            <div className='col-md-12'>
              <Suspense fallback={<Loading styles='mini' />}>
                <TraficTableProducer />
              </Suspense>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
